import script from "./NotificationDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDetailModal.vue?vue&type=style&index=0&id=aab733be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab733be"]])

export default __exports__